import Navbar from '../assets/Navbar/Navbar';
import Hero from "../assets/Hero/Hero";
import Content from "../assets/Content/Content";
import Footer from "../assets/Footer/Footer";
import ContentAbout from '../assets/Content/ContentAbout';



function About() {
    return (
      <><Navbar/>
      <div className="line"></div>

      
      <ContentAbout />
      


      <Footer />
        
      </>
    );
  }

export default About;